import { mapGetters, mapActions } from 'vuex';
import {
    GET_ADVANTAGE_LIST,
    GET_SLIDER_PRODUCTS,
    GET_MAIN_SLIDER,
    GET_CONFIG
} from '@/store/action-types';
import Slider from '@/components/slider/index.vue';
import CatalogList from '@/components/catalog-list/index.vue';
import SliderProducts from '@/components/slider-products/index.vue';
import seoText from '@/components/text-seo/index.vue';

export default {
    name: 'home',
    data(){
        return {
            openReadMore: false,
            params: {
                title: this.$t('logo'),
                description: this.$t('siteDescription'),
                keywords: this.$t('logo'),
                image: require('@/assets/img/sharing.png')
            },
        }
    },
    head: {
        title () {
            return {
                inner: this.params.title,
                separator: ' ',
                complement: ''
            }
        },
        meta () {
            let meta = [
                { n: 'description', c: this.params.description, id: 'description' },
                { n: 'keywords', c: this.params.keywords, id: 'keywords' },
                { n: 'og:title', c: this.params.title, id: 'og:title' },
                { n: 'og:description', c: this.params.description, id: 'og:description' },
                { p: 'og:image', c: this.params.image, id: 'og:image' },
            ]

            if (Object.keys(this.$route.query).length > 0) {
                meta.push({ n: 'robots', c: 'noindex, nofollow' })
                return meta
            } else {
                return meta
            }
        },
        link () {
            let route = this.$route.path
            return [
                { rel: 'canonical', href: window.location.origin + this.$route.path, id: 'canonical' },
            ]
        }
    },
    created(){
        this.fetchProductsListSlider();
        if(!this.advantageList){
            this.fetchAdvantageList();
        }
        this.fetchMainSlider();
        this.fetchConfig();
    },
    computed: {
        ...mapGetters({
            translations: 'setting/translations',
            menu: 'setting/menu',
            advantageList: 'home/advantageList',
            advantageListLoading: 'home/advantageListLoading',
            config: 'setting/config',
            configLoading: 'setting/configLoading',
            menuLoading: 'setting/menuLoading',
            sliderProductsList: 'popularProducts/sliderProductsList',
            sliderProductsListLoading: 'popularProducts/sliderProductsListLoading',
            mainSlider: 'home/mainSlider',
            mainSliderLoading: 'home/mainSliderLoading',
        }),
        ...mapGetters([
            'languages',
            'currentLanguage',
        ]),
        getMainBanner(){
            return this.config.find(e => {
                if(e.key === 'main_banner'){
                    return e;
                }
            });
        },
        getMainText(){
            return this.config.find(e => {
                if(e.key === 'main_page_text'){
                    return e;
                }
            });
        }

    },
    components: {
        Slider,
        CatalogList,
        seoText,
        SliderProducts
    },
    methods: {
        ...mapActions({
            fetchAdvantageList: `home/${GET_ADVANTAGE_LIST}`,
            fetchConfig: `setting/${GET_CONFIG}`,
            fetchMainSlider: `home/${GET_MAIN_SLIDER}`,
            fetchProductsListSlider: `popularProducts/${GET_SLIDER_PRODUCTS}`,
        }),
        setCurrentLocaleInMainBanner(link){
            if(link.includes('/uk/')){
                return link.replace('/uk/', `/${this.currentLanguage.key}/`)
            }
            if(link.includes('/ru/')){
                return link.replace('/ru/', `/${this.currentLanguage.key}/`)
            }
            if(link.includes('/en/')){
                return link.replace('/en/', `/${this.currentLanguage.key}/`)
            }
        }
    }
}
